@if (sessionExpiry.visible()) {
  <div class="modal-backdrop session-expiry-backdrop" role="presentation">
    <div
      class="ent-modal session-expiry-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="sessionExpiryTitle"
      (click)="$event.stopPropagation()"
    >
      <div class="modal-header">
        <h2 id="sessionExpiryTitle">Session Expiring</h2>
      </div>

      <div class="modal-body">
        <p class="session-expiry-message">
          Your session is about to renew.
          @if (sessionExpiry.secondsRemaining() > 0) {
            <span class="session-expiry-countdown">
              Auto-renew in:
              <strong>{{ sessionExpiry.secondsRemaining() }}s</strong>
            </span>
          }
        </p>
        <p class="session-expiry-hint">Stay on this page — we will keep you signed in.</p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn-secondary"
          [disabled]="sessionExpiry.isRefreshing()"
          (click)="onLogout()"
        >
          Log out
        </button>
        <button
          type="button"
          class="btn-primary"
          [disabled]="sessionExpiry.isRefreshing()"
          (click)="onStayLoggedIn()"
        >
          @if (sessionExpiry.isRefreshing()) {
            Extending…
          } @else {
            Stay logged in
          }
        </button>
      </div>
    </div>
  </div>
}
